import { ChangeDetectionStrategy, Component, effect, input, model, output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { CisAllegato, CisUpdateAllegatoRequest } from 'src/app/shared/models/cisAllegato.model';
import { Documento } from 'src/app/shared/models/documento.model';

@Component({
  selector: 'app-distruzione-restituzione-cis-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="{{this.distruzione() ? 'Distruzione' : 'Restituzione'}}" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()" [style]="{'width':'400px'}" >

    <label for="dal" class="small-label">Data Operazione</label>
    <p-calendar [showIcon]="true" dateFormat="dd/mm/yy" [selectOtherMonths]="true" appendTo="body" [(ngModel)]="updateCISRequest.operazioneData"
    [inputStyle]="{'width': '187px'}">
    </p-calendar>
    <label for="firma" class="small-label">Firma</label>
    <textarea pInputTextarea id="firma" class="text-area-dialog" [rows]="3" [cols]="50" [(ngModel)]="updateCISRequest.operazioneFirma" required></textarea>
    <label for="note" class="small-label">Note</label>
<div class="textarea-wrapper">
  <textarea
    pInputTextarea
    id="note"
    class="text-area-dialog"
    [rows]="3"
    [cols]="50"
    [maxlength]="300"
    [(ngModel)]="updateCISRequest.note">
  </textarea>
  <span class="char-counter" [class.near-limit]="(updateCISRequest.note?.length || 0) >= 270">
    {{ updateCISRequest.note?.length || 0 }}/300
  </span>
</div>    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      @if (distruzione()) {
      <button pButton type="button" class="p-button-danger" icon="fas fa-fw fa-trash" label="Distruggi" (click)="update_click()"
      [disabled]="!updateCISRequest.operazioneData|| !updateCISRequest.operazioneFirma"></button>
      }
      @else {
      <button pButton type="button" class="p-button-primary" icon="fas fa-fw fa-reply" label="Restituisci" (click)="update_click()"
      [disabled]="!updateCISRequest.operazioneData|| !updateCISRequest.operazioneFirma"></button>
      }
    </p-footer>
  </p-dialog>
  `,
  styles: [`
  label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  .text-area-dialog { min-height: 40px; width: 100%; }
  .textarea-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.char-counter {
  position: absolute;
  bottom: 8px;
  right: 10px;
  font-size: 0.75rem;
  color: #888;
  pointer-events: none;
}

.char-counter.near-limit {
  color: #e53935;
  font-weight: 600;
}
  `]
})

export class DistruzioneRestituzioneCISDialogComponent {
  visible = model<boolean>(false);
  distruzione = input.required<boolean>();
  allegatoCIS = input<CisAllegato | undefined>();
  documento = input<Documento | undefined>();
  hide = output();
  update = output<CisUpdateAllegatoRequest>();

  public updateCISRequest: CisUpdateAllegatoRequest = {} as CisUpdateAllegatoRequest;

  constructor(private confirmationService: ConfirmationService) {
    effect(() => {
      if (this.visible() && this.documento()?.dataProtocollazione) {
        this.initializeRequest();
      }
    });
  }

  private initializeRequest() {
    this.updateCISRequest = {
      documentoId: this.documento()!.documentoId,
      numeroOrdine: this.allegatoCIS()!.numeroOrdine,
      registroData: this.documento()!.dataProtocollazione!,
      distruzione: this.distruzione(),
      operazioneData: new Date(),
      operazioneFirma: this.distruzione() ? 'Il capo della segreteria speciale' : '',
      note: ''
    };
  }

  hideDialog(): void {
    this.hide.emit();
  }

  update_click(): void {
    this.confirmationService.confirm({
      header: this.distruzione() ? 'Distruzione allegato CIS' : 'Restituzione allegato CIS',
      message: `<strong>${this.distruzione() ? 'Distruggere' : 'Restituire'}</strong> l'allegato CIS?
      <p>L'operazione che si sta per compiere è un processo <strong>IRREVERSIBILE</strong> che impedirà ogni ulteriore modifica all'allegato.</p>`,
      acceptLabel: this.distruzione() ? 'Distruggi' : 'Restituisci',
      icon: this.distruzione() ? 'fas fa-fw fa-trash' : 'fas fa-fw fa-reply',
      accept: () => {
        this.update.emit(this.updateCISRequest);
        this.hideDialog();
      }
    });
  }
}
